<template>
  <div>
    <v-select
      class="rounded-lg mt-4"
      dense
      label="Тип ссылки"
      :items="localSubjectTypeList"
      v-model="localSubjectType"
      item-text="label"
      item-value="value"
      outlined
      :disabled="disabled"
    ></v-select>
    <v-text-field
      v-if="localSubjectType === localSubjectTypeEnum.EXTERNAL_LINK"
      v-model="item.action_link"
      class="rounded-lg mt-4"
      dense
      label="Внешняя ссылка"
      outlined
      :rules="[rules.required, rules.maxLength(128)]"
      aria-required="true"
      :disabled="disabled"
    ></v-text-field>
    <v-autocomplete
      v-if="subjectIdModel"
      label="Связанный элемент"
      class="rounded-lg mt-4"
      dense
      outlined
      :disabled="disabled || subjectIdModelLoading"
      v-model="selectedSubjectId"
      :items="subjectIdModelItems"
      item-value="value"
      item-text="label"
      :return-object="false"
      :rules="[rules.required]"
      aria-required="true"
    >
      <template v-slot:append>
        <v-progress-circular
          v-if="subjectIdModelLoading"
          size="20"
          width="2"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
  import rules from 'air-vue-model/rules'
  import { defineComponent } from 'vue'
  import { isObject } from 'lodash'
  import { userNotificationPlaceholders } from '@/services/userNotificationPlaceholders'

  export default defineComponent({
    name: 'LinkType',
    components: {},
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      item: Object
    },
    data: () => {
      const localSubjectTypeEnum = {
        EXTERNAL_LINK: 1,
        BONUS_PAGE: 2,
        PROMO_PAGE: 3,
        PRODUCT_GROUP_PAGE: 4,
        PRODUCT_PAGE: 5
      }
      const localSubjectTypeName = {
        [localSubjectTypeEnum.EXTERNAL_LINK]: 'Внешняя ссылка',
        [localSubjectTypeEnum.BONUS_PAGE]: 'Страница бонусов',
        [localSubjectTypeEnum.PROMO_PAGE]: 'Страница промо',
        [localSubjectTypeEnum.PRODUCT_GROUP_PAGE]: 'Страница группы продуктов',
        [localSubjectTypeEnum.PRODUCT_PAGE]: 'Страница продукта'
      }
      return {
        placeholders: userNotificationPlaceholders,
        localSubjectType: localSubjectTypeEnum.BONUS_PAGE,
        localSubjectTypeEnum,
        imageKey: 1,
        localSubjectTypeList: Object.keys(localSubjectTypeName).map(_key => {
          const key = Number(_key)
          return {
            label: localSubjectTypeName[key],
            value: key
          }
        })
      }
    },
    mounted() {
      this.localSubjectType = this.item.action_type
      this.selectedSubjectId = this.selectedSubjectId
      this.loadDataBySubjectTypeId(this.item.action_type)
    },
    computed: {
      rules() {
        return {
          ...rules,
          maxLength: p => v => (v?.length ?? 0) <= p || `Максимальная длина ${p}`
        }
      },
      subjectIdModelLoading() {
        return this.subjectIdModel?.loadings?.list || false
      },
      validSubjectTypeId() {
        return (
          this.localSubjectType !== this.localSubjectTypeEnum.EXTERNAL_LINK &&
          this.localSubjectType !== this.localSubjectTypeEnum.BONUS_PAGE
        )
      },
      subjectIdModel() {
        const mapping = {
          [this.localSubjectTypeEnum.EXTERNAL_LINK]: null,
          [this.localSubjectTypeEnum.BONUS_PAGE]: null,
          [this.localSubjectTypeEnum.PROMO_PAGE]: null,
          [this.localSubjectTypeEnum.PRODUCT_GROUP_PAGE]: this.$productGroup,
          [this.localSubjectTypeEnum.PRODUCT_PAGE]: this.$product
        }
        const item = mapping[this.localSubjectType] || null
        return item
      },
      selectedSubjectId: {
        get() {
          if (this.localSubjectType === this.localSubjectTypeEnum.PRODUCT_PAGE) {
            const subject = this.item.action_product
            if (isObject(subject)) {
              return String(subject.id)
            }

            return String(subject)
          } else if (this.localSubjectType === this.localSubjectTypeEnum.PRODUCT_GROUP_PAGE) {
            const subject = this.item.action_product_group
            if (isObject(subject)) {
              return String(subject.id)
            }
            return String(subject)
          } else {
            return null
          }
        },
        set(value) {
          if (this.localSubjectType == this.localSubjectTypeEnum.PRODUCT_PAGE) {
            this.item.action_product = value
            this.item.action_product_group = null
          } else if (this.localSubjectType == this.localSubjectTypeEnum.PRODUCT_GROUP_PAGE) {
            this.item.action_product = null
            this.item.action_product_group = value
          } else {
            this.item.action_product = null
            this.item.action_product_group = null
          }
        }
      },
      subjectIdModelItems() {
        const mapping = new Map()
        mapping.set(this.$product, {
          label: 'vendor_name|name',
          value: 'id',
          showInApp: 'show_in_app'
        })
        mapping.set(this.$productGroup, {
          label: 'vendor_name|name',
          value: 'id',
          showInApp: 'show_in_app'
        })

        const items = this.subjectIdModel?.list || []
        const res = items.map(v => {
          const mappingItem = mapping.get(this.subjectIdModel)
          if (!mappingItem) throw Error('Mapping not found')

          const getFirstNonEmptyValue = (obj, fields) => {
            const fieldList = fields.split('|')
            for (const field of fieldList) {
              if (obj[field]) return obj[field]
            }
            return ''
          }

          return {
            label: mappingItem.label.includes('|')
              ? getFirstNonEmptyValue(v, mappingItem.label)
              : v[mappingItem.label],
            value: String(v[mappingItem.value]),
            showInApp: v[mappingItem.showInApp]
          }
        })

        return res.filter(e => e.showInApp).sort((a, b) => a.label.localeCompare(b.label))
      }
    },
    methods: {
      loadDataBySubjectTypeId(v) {
        const model = this.subjectIdModel
        if (!model) {
          this.selectedSubjectId = null
          return
        }
        if (
          v === this.localSubjectTypeEnum.PRODUCT_PAGE ||
          v === this.localSubjectTypeEnum.PRODUCT_GROUP_PAGE
        ) {
          model.loadList({ page_size: 'all' })
        }
      }
    },
    watch: {
      localSubjectType(v) {
        console.log('set subject_id', v)

        if (
          v === this.localSubjectTypeEnum.EXTERNAL_LINK &&
          this.item.action_type !== this.localSubjectTypeEnum.EXTERNAL_LINK
        ) {
          this.item.action_type = this.localSubjectTypeEnum.EXTERNAL_LINK
        } else if (v !== this.localSubjectTypeEnum.EXTERNAL_LINK) {
          this.item.action_link = null
        }

        this.item.action_type = v
        this.loadDataBySubjectTypeId(v)
      }
    }
  })
</script>

<style scoped>
  :deep(.v-text-field__details) {
    position: absolute;
    bottom: -20px;
  }

  :deep(.v-textarea .v-input__slot),
  :deep(.v-text-field .v-input__slot) {
    padding-right: 40px !important;
  }
</style>
